import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WorkInProgressComponent } from '../../components/shared/work-in-progress/work-in-progress.component';

@Component({
  selector: 'inexp-contact',
  imports: [WorkInProgressComponent],
  template: `<inexp-work-in-progress />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent {}
